import { GetterTree } from 'vuex/types/index'
import { ApplicationsState, ApplicationResource, Application } from './applications.types'
import { AttachmentType, Attachment } from '~/store/applications/attachments/attachments.types'
import { getResource } from '~/utils/store'
import { RootState } from '~/store/store.types'

const getAttachmentWithType = (application: Application, type: AttachmentType) => {
  if (!application.attachments) {
    return {}
  }

  const attachment = application.attachments.reverse().find(attachment => attachment.attachmentType === type)

  if (!attachment) {
    return {}
  }

  return attachment
}

const getters: GetterTree<ApplicationsState, RootState> = {
  applications (state, getters, _, __): Application[] {
    return Object.values(state.data).map(({ id }) => getters.applicationById(id))
  },

  genders ({ meta }): string[] {
    if (meta) {
      return meta.genderList
    }

    return []
  },

  occupations ({ meta }): string[] {
    if (meta) {
      return meta.occupationList
    }

    return []
  },

  naturesOfBusiness ({ meta }): string[] {
    if (meta) {
      return meta.natureOfBusinessList
    }

    return []
  },

  applicationById (state, _, __, rootGetters): Function {
    return (id: string) => getResource<ApplicationResource>(state, id, rootGetters, ['product', 'attachment', 'submission'], {
      products: 'applications/products/productById',
      attachments: 'applications/attachments/attachmentById',
      'application_submissions': 'applications/submissions/submissionById'
    })
  },

  hasApplicationSubmitted (_, getters, __, ___): Function {
    return (id: string) => {
      const application = getters.applicationById(id)

      return !!application.submissions.length
    }
  },

  headshotForApplication (_, getters, __, ___): Function {
    return (id: string) => {
      const application = getters.applicationById(id)

      return getAttachmentWithType(application, AttachmentType.Headshot)
    }
  },

  identificationForApplication (_, getters, __, ___): Function {
    return (id: string) => {
      const application = getters.applicationById(id)

      return getAttachmentWithType(application, AttachmentType.Identification)
    }
  }
}

export default getters
